var React = require('react');

function TvAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M520 448H120a24 24 0 0 0-24 24v16a24 24 0 0 0 24 24h400a24 24 0 0 0 24-24v-16a24 24 0 0 0-24-24zM592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h544a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M576 352H64V64h512z","className":"fa-primary","key":2})]);
}

TvAlt.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = TvAlt;

TvAlt.default = TvAlt;
